import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#636363",
      d: "M12 4.929 9.17 7.757l1.415 1.415 2.828-2.829a3.01 3.01 0 0 1 4.243 0 3.01 3.01 0 0 1 0 4.243l-2.829 2.828 1.415 1.415L19.07 12a5 5 0 0 0 0-7.071 5 5 0 0 0-7.071 0m1.414 9.9-2.828 2.828a3.01 3.01 0 0 1-4.243 0 3.01 3.01 0 0 1 0-4.243l2.828-2.828-1.414-1.414L4.93 12a5 5 0 0 0 0 7.071 5 5 0 0 0 7.07 0l2.83-2.828zm-4.95-.708 5.657-5.656 1.414 1.414-5.656 5.657z"
    }, null, -1)
  ]))]))
}
export default { render: render }